import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostListener,
  OnInit,
} from '@angular/core';
import {
    RouterLink,
    RouterOutlet,
    Router,
    NavigationEnd,
} from '@angular/router';
import { AreaLogadaModule } from './area-logada.module';
import { register } from 'swiper/element/bundle';
import { trigger, transition, style, animate } from '@angular/animations';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SegmentacaoService } from '../../services/segmentacao.service';
import { SaldoService } from '../../services/saldo.service';
import { Saldo } from '../../interfaces/saldo/saldo.interface';
import { NumberUtil } from '../../infra/number-util';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../../services/home.service';
import { Notificacao } from '../../interfaces/notificacao/notificacao.interface';
import { AuthService } from '../../services/auth.service';
import { SaldoUtil } from '../../infra/saldo-util';
import { EnumPermissao } from '../../enums/permissoes.enum';
import { RecargaService } from '../../services/recarga.service';
import { SignalRService } from '../../services/signalr.service';
import { NotificationData } from '../../interfaces/notificacao/signalr.interface';
import { EnumNotificationType } from '../../enums/notification.enum';
import tippy, { Instance as TippyInstance } from 'tippy.js';
declare var bootstrap: any;

register();

@Component({
    selector: 'app-area-logada',
    imports: [
        RouterOutlet,
        AreaLogadaModule,
        RouterLink,
        CommonModule,
        NumberUtil,
    ],
    templateUrl: './area-logada.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-10px)' }),
                animate(
                    '200ms ease-out',
                    style({ opacity: 1, transform: 'translateY(0)' })
                ),
            ]),
            transition(':leave', [
                animate(
                    '200ms ease-in',
                    style({ opacity: 0, transform: 'translateY(-10px)' })
                ),
            ]),
        ]),
    ],
})
export class AreaLogadaComponent implements OnInit, AfterViewInit {
  EnumPermissao = EnumPermissao;
  isNotificacoesVisible = false;
  isUserMenuVisible = false;
  showSearchLista = false;
  showSearchContatos = false;
  userIp = '';
  notificacoes: Notificacao[] = [];
  notificacoesSignalR: NotificationData[] = [];
  carregandoSaldo = true;
  menuExpanded: boolean = true;
  saldo: Saldo = {
    quantidade: 0,
    motivo: 0,
    mensagemMotivoSaldo: '',
    tipo: '',
  };
    private menuTooltips: TippyInstance[] = [];
    ultimoSaldoValido: Saldo | null = null;
    private atualizandoSaldo = false;

    constructor(
        private router: Router,
        private segmentacaoService: SegmentacaoService,
        private saldoService: SaldoService,
        private homeService: HomeService,
        private toastr: ToastrService,
        private authService: AuthService,
        private recargaService: RecargaService,
        private signalRService: SignalRService,
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.showSearchLista = event.url.includes('/listas');
                this.showSearchContatos = event.url.includes('/contatos');
            });
    }

    get temNotificacoes(): boolean {
        return this.notificacoes.length > 0;
    }

    async ngOnInit() {
        this.loadMenuState();

        await Promise.all([
            this.carregarSaldo(),
            this.carregarIp(),
            this.carregarNotificacoes(),
            this.conectarSignalR(),
        ]);
    }

  ngAfterViewInit() {
    setTimeout(() => {
      this.inicializarMenuTooltips();
    }, 500);
  }

  ngOnDestroy(): void {
    this.signalRService.stopConnection();
    this.destruirTooltips();
  }

  private inicializarMenuTooltips(): void {
    this.destruirTooltips();
    
    const menuItems = document.querySelectorAll('.menu-item a');
    
    menuItems.forEach((item) => {
      const texto = item.querySelector('.texto')?.textContent?.trim();
      if (texto) {
        const instance = tippy(item as Element, {
          content: texto,
          placement: 'right',
          arrow: true,
          theme: 'light',
          offset: [0, 15],
          appendTo: document.body,
          trigger: 'mouseenter',
          hideOnClick: false,
          onShow(instance) {
            const menuAberto = document.body.getAttribute('menu-opened') === 'false';
            return menuAberto ? false : undefined;            
          }
        });
        
        this.menuTooltips.push(instance);
      }
    });
  }

  private destruirTooltips(): void {
    this.menuTooltips.forEach(tooltip => {
      tooltip.destroy();
    });
    this.menuTooltips = [];
  }

  toggleMenu(): void {
    this.menuExpanded = !this.menuExpanded;
    document.body.setAttribute('menu-opened', this.menuExpanded ? 'false' : 'true');
    localStorage.setItem('menuState', this.menuExpanded ? 'true' : 'false');
    
    this.inicializarMenuTooltips();
  }

  private loadMenuState(): void {
    const savedState = localStorage.getItem('menuState');
    if (savedState !== null) {
      this.menuExpanded = savedState === 'true';
      document.body.setAttribute('menu-opened', this.menuExpanded ? 'false' : 'true');
    }

    this.inicializarMenuTooltips();
  }

    async conectarSignalR() {
        try {
            const tokenRecarga = await this.recargaService.obterTokenRecarga();
            await this.signalRService.negotiateConnection(tokenRecarga);

            this.signalRService.novoEvento(async (data: NotificationData) => {
                this.notificacoesSignalR.push(data);

                if (data.Type === EnumNotificationType.Payment) {
                    try {
                        this.atualizandoSaldo = true;
                        const novoSaldo = await this.saldoService.obterSaldo();

                        const respostaValida = novoSaldo !== null && novoSaldo !== undefined;

                        if (respostaValida) {
                            this.saldo = novoSaldo;
                            this.ultimoSaldoValido = novoSaldo;
                        } else if (this.ultimoSaldoValido) {
                            this.saldo = this.ultimoSaldoValido;
                        }

                        const modalRecargaElement = document.getElementById('modalRecarga');
                        if (modalRecargaElement) {
                            const modalRecarga = bootstrap.Modal.getInstance(modalRecargaElement);
                            modalRecarga?.hide();
                        }
                    } catch (error) {
                        console.error('Erro ao atualizar saldo:', error);
                        if (!this.ultimoSaldoValido) {
                            this.toastr.error('Erro ao atualizar saldo.');
                        }
                    } finally {
                        this.atualizandoSaldo = false;
                    }
                }
            });
        } catch (error) {
            console.error('Erro ao conectar ao SignalR:', error);
        }
    }

    async carregarSaldo() {
        try {
            const saldoAnterior = this.saldo;

            this.atualizandoSaldo = true;

            const novoSaldo = await this.saldoService.obterSaldoAtual();

            if (novoSaldo !== null && novoSaldo !== undefined) {
                this.saldo = novoSaldo;
                this.ultimoSaldoValido = novoSaldo;
            } else if (this.ultimoSaldoValido) {
                this.saldo = this.ultimoSaldoValido;
            }
        } catch (error) {
            console.error('Erro ao carregar saldo:', error);
            if (this.ultimoSaldoValido) {
                this.saldo = this.ultimoSaldoValido;
            }
        } finally {
            this.atualizandoSaldo = false;
        }
    }

    private async carregarNotificacoes() {
        const response = await this.homeService.BuscarNotificacoes();
        this.notificacoes = response.notificacoes;
    }

    async toggleNotificacoes() {
        this.isNotificacoesVisible = !this.isNotificacoesVisible;
    }

    async navegarParaRecargas(event: Event) {
        await this.recargaService.navegarParaRecargas(event);
        this.isUserMenuVisible = false;
    }

  async navegarParaRelatorios(event: Event) {
    await this.recargaService.navegarParaRelatorios(event);
    this.isUserMenuVisible = false;
  }

  async navegarParaSegmentacao(event: Event) {
    event.preventDefault();
    await SaldoUtil.navegarParaSegmentacao(
      this.saldoService,
      this.router,
      this.toastr
    );
    this.segmentacaoService.setAbrangenciaSelecionada([
      'FEDERAL',
      'ESTADUAL',
      'MUNICIPAL',
    ]);
  }

    async marcarComoLida(notificacao: Notificacao) {
        await this.homeService.marcarComoLida(notificacao.idNotificacao);
        this.notificacoes = this.notificacoes.filter(
            (n) => n.idNotificacao !== notificacao.idNotificacao
        );
    }

    toggleUserMenu() {
        this.isUserMenuVisible = !this.isUserMenuVisible;
    }

    navegarParaUsuarios() {
        this.router.navigate(['/area-logada/usuarios']);
        this.isUserMenuVisible = false;
    }

  navegarParaMeusDados() {
    this.router.navigate(['/area-logada/meus-dados']);
    this.isUserMenuVisible = false;
  }

  logout() {
    this.authService.logout();
    this.isUserMenuVisible = false;
  }

    getNomeUsuario(): string {
        return this.authService.getNomeUsuario();
    }

    private async carregarIp() {
        this.userIp = this.authService.getIpUsuario();
    }

    verificarConexaoSignalR() {
        if (this.signalRService.isConnectionLost()) {
            this.conectarSignalR();
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutside(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (this.isUserMenuVisible) {
            const isClickInside =
                target.closest('.user-menu-trigger') ||
                target.closest('.user-menu-lista');
            if (!isClickInside) {
                this.isUserMenuVisible = false;
            }
        }

        if (this.isNotificacoesVisible) {
            const isClickInsideNotif =
                target.closest('.notificacoes-trigger') ||
                target.closest('.notificacoes-lista');
            if (!isClickInsideNotif) {
                this.isNotificacoesVisible = false;
            }
        }
    }

    @HostListener('window:focus', ['$event'])
    async onWindowFocus() {
        if (document.hasFocus()) {
            try {
                this.atualizandoSaldo = true;
                await this.saldoService.obterSaldoAtual();
                this.verificarConexaoSignalR();
            } catch (error) {
                console.error('Erro ao atualizar saldo em foco:', error);
            } finally {
                this.atualizandoSaldo = false;
            }
        }
    }
}
